import { CreateOpportunityFlow, OpportunityFlow, UpdateOpportunityFlow } from '@/entities/opportunityFlow';
import { OpportunityFlowWithBusiness } from '@/entities/opportunityFlowWithBusiness';
import { OpportunityFlowService } from '@/services/OpportunityFlowService';
import { useEffect, useState} from 'react';
export function useOpportunityFlow() {
  const [opportunityFlows, setOpportunityFlows] = useState<OpportunityFlow[]>([]);
  const [searchedOpportunityFlows, setSearchedOpportunityFlows] = useState<OpportunityFlow[]>([]);
  const [opportunityFlowsWithBusiness, setOpportunityFlowsWithBusiness] = useState<OpportunityFlowWithBusiness[]>([]);
  const [collabOpportunityFlowWithBusienss, setCollabOpportunityFlowWithBusiness] = useState<OpportunityFlowWithBusiness[]>([]);
  const [errorFetchOpportunityFlowsWithBusiness, setErrorFetchOpportunityFlowsWithBusiness] = useState(false);
  const [errorFetchOpportunityFlows, setErrorFetchOpportunityFlows] = useState(false);
  const [saveOpportunityFlowsError, setSaveOpportunityFlowsError] = useState(false);
  const [searchOpportunityFlowsError, setSearchOpportunityFlowsError] = useState(false);
  const [nextOrder, setNextOrder] = useState<number>(0);
  const [createOpportunityFlowError, setCreateOpportunityFlowError] = useState(false);
  const [deletOpportunityFlow, setDeleteOpportunityFlowError] = useState(false);
  const [createManyOpportunityFlowError, setCreateManyOpportunityFlowError] = useState(false);
  const retryRequest = async <T>(
    requestFn: () => Promise<T>,
    maxRetries = 3,
    delay = 5000
  ): Promise<T | null> => {
    for (let attempt = 0; attempt < maxRetries; attempt++) {
      try {
        return await requestFn();
      } catch (error: any) {
        if (error.response?.status === 401) {
          if (attempt < maxRetries - 1) {
            await new Promise(res => setTimeout(res, delay));
          }
        } else {
          throw error; // erro diferente de 401, não faz sentido continuar tentando
        }
      }
    }
    return null;
  };
  
  useEffect(() => {
    const fetchOpportunityFlows = async () => {
      try {
        const response = await retryRequest(() =>
          OpportunityFlowService.getOpportunityFlow()
        );
    
        if (response) {
          const op2 = response.map((flow) => ({
            id: flow.id,
            order: flow.order,
            description: flow.description
          })).sort((a, b) => a.order - b.order);
    
          setOpportunityFlows(op2);
          setNextOrder(op2[op2.length - 1].order + 1);
        }
      } catch (error) {
        console.log(error);
        setErrorFetchOpportunityFlows(true);
      }
    };

    const getAllOpportunityFlowWithbusiness = async () => {
      try {
        const response = await retryRequest(() =>
          OpportunityFlowService.getOpportunityFlowWithBusiness()
        );
    
        if (response) {
          setOpportunityFlowsWithBusiness(response);
        }
      } catch (error) {
        console.log(error);
        setErrorFetchOpportunityFlowsWithBusiness(true);
      }
    };

    fetchOpportunityFlows();
    getAllOpportunityFlowWithbusiness();
  }, []);

  const swapOpportunityFlows = async (firstOpportunityFlowId: number, secondOpportunityFlowId: number) => {
    const response = await OpportunityFlowService.swapOpportunityFlows(firstOpportunityFlowId, secondOpportunityFlowId);
  };

  const getOpportunityFlowWithBusinessbyId = async (companyId: number, userId: number) => {
    const response = await OpportunityFlowService.getOpportunityFlowWithBusinessbyId(companyId,userId)
    if(response){
      return response;
    }
  }

  // todo: adicionar função para remove fluxo de oportunidade.

  const changeOpportunityFlowOfBusiness = async (businessId: number, opportunityFlowId: number, contactNumber: string) => {
    const response = await OpportunityFlowService.changeOpportunityFlowOfBusiness(businessId, opportunityFlowId,contactNumber); 
    // if (response) setOpportunityFlowsWithbusiness(response);
  };

  const saveOpportunityFlows = async (opportunityFlows: UpdateOpportunityFlow[]) => {
    try {
      await OpportunityFlowService.updateManyOpportunityFlow(opportunityFlows);
    } catch (error) {
      console.log(error);
      setSaveOpportunityFlowsError(true);
    }
  };

  const createOpportunityFlow = async (opportunityFlows: OpportunityFlow) => {
    try{
      await OpportunityFlowService.createNewOpportunityFlow(opportunityFlows);
    } catch(error){
      console.log(error);
      setCreateOpportunityFlowError(true);
    }
  };

  const createManyOpportunityFlow = async (opportunityFlows: CreateOpportunityFlow[]) => {
    try{
      await OpportunityFlowService.createManyOpportunityFlow(opportunityFlows);
    } catch(error){
      console.log(error);
      setCreateManyOpportunityFlowError(true);
    }
  };

  const deleteOpportunityFlow = async(id:number) => {
    try{
      await OpportunityFlowService.deleteOpportunityFlow(id);
    } catch(error){
      console.log(error);
      setDeleteOpportunityFlowError(true);
    }
  };

  const searchOpportunityFlows = async(contain: string) => {
    try{
      const response = await OpportunityFlowService.searchOpportunityFlow(contain);
      // console.log(response);
      if (response) {
        const op2 = response.map((flow: { id: any; order: any; description: any; }) => ({
          id: flow.id,
          order: flow.order,
          description: flow.description
        })).sort((a: { order: number; }, b: { order: number; }) => a.order - b.order);
        setSearchedOpportunityFlows(op2);
      }
    }catch(error){
      console.log(error);
      setSearchOpportunityFlowsError(true);
    }
  };

  return {
    collabOpportunityFlowWithBusienss,
    opportunityFlows,
    errorFetchOpportunityFlows,
    opportunityFlowsWithBusiness,
    saveOpportunityFlowsError,
    createOpportunityFlowError,
    searchedOpportunityFlows,
    deletOpportunityFlow,
    nextOrder,
    setOpportunityFlows,
    searchOpportunityFlows,
    swapOpportunityFlows,
    saveOpportunityFlows,
    changeOpportunityFlowOfBusiness,
    createOpportunityFlow,
    createManyOpportunityFlow,
    deleteOpportunityFlow,
    setNextOrder,
    getOpportunityFlowWithBusinessbyId
  };
}
